import { useCallback, useRef, useState } from 'react';
import { useUnmountEffect } from './use-unmount-effect.js';
/**
 * Force the component to be updated(re-render) until the component is unmounted.
 */
export function useForceUpdate() {
  const unloadingRef = useRef(false);
  const [count, setCount] = useState(0);

  useUnmountEffect(() => {
    unloadingRef.current = true;
  });

  return useCallback(() => {
    if (!unloadingRef.current) {
      setCount(count + 1);
    }
  }, [count]);
}
